import React from "react";
import { Description } from "../../atoms/description";
import "./minimalist.m.css";

export const DataBlock = ({ mode, subscriptionConfig, group }) => {
  const { description } = group;
  const { pageTitle = "", pageDescription = "", descriptionTitle } = subscriptionConfig;
  const emptyString = "<p><br></p>";
  const updatedPageTitle = pageTitle === emptyString ? "" : pageTitle;
  const updatedPageDescription = pageDescription === emptyString ? "" : pageDescription;
  const space = updatedPageDescription ? "space" : "";
  return (
    <div styleName={`container ${mode}`}>
      {(pageDescription || pageTitle) && (
        <div>
          {updatedPageTitle && (
            <h1
              styleName={`page-title ${space}`}
              data-test-id="page-title"
              dangerouslySetInnerHTML={{ __html: pageTitle }}
            />
          )}
          {updatedPageDescription && (
            <div
              styleName="page-description"
              data-test-id="page-description"
              dangerouslySetInnerHTML={{ __html: pageDescription }}
            />
          )}
        </div>
      )}
      <Description
        data={description}
        descriptionTitle={descriptionTitle}
        mode={mode}
        displayDescription={true}
        type="group"
      />
    </div>
  );
};
